import { AddEmployeeModalFragment, DataSchemaItemFragment } from 'generated/resources/graphql'
import { groupBy } from 'lodash'

import { isValidEmail } from 'modules/core/lib/email'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from './types'

export const CENTS = 100

export const MIN_PERCENTAGE_WORKING_HOURS = 1
export const MAX_PERCENTAGE_WORKING_HOURS = 100

export const constraintToWorkingHoursTimePercentage = (percentage: number): number => {
  percentage = Math.max(MIN_PERCENTAGE_WORKING_HOURS, percentage)
  percentage = Math.min(MAX_PERCENTAGE_WORKING_HOURS, percentage)
  return percentage
}

export function getStringFieldValue(key: keyof WizardData, data: WizardData) {
  const value = data[key]
  return typeof value === 'string' ? value : ''
}

export const groupFieldsByGroup = (
  fields?: DataSchemaItemFragment[]
): Record<string, DataSchemaItemFragment[]> => {
  return groupBy(fields, (field) => field.group || `ungrouped_${field.fieldName}`)
}

type ValidateEmailType = 'empty' | 'terminated' | 'existing_employee' | 'invalid_email'

type EmailValidation =
  | { valid: true }
  | { valid: false; errorType: ValidateEmailType; errorString: string }

export const validateEmailForCreation = (
  email: string,
  employees: AddEmployeeModalFragment[]
): EmailValidation => {
  if (!email) return { valid: false, errorType: 'empty', errorString: i18n.t('common.empty') }

  const existingEmployee = employees.find((emp) => emp.email === email)

  if (existingEmployee?.terminatedOn) {
    return {
      valid: false,
      errorType: 'terminated',
      errorString: i18n.t('employee_form.onboarding.existing_employee_terminated'),
    }
  }

  if (existingEmployee) {
    return {
      valid: false,
      errorType: 'existing_employee',
      errorString: i18n.t('employee_form.onboarding.existing_employee'),
    }
  }

  if (!isValidEmail(email)) {
    return {
      valid: false,
      errorType: 'invalid_email',
      errorString: i18n.t('employee_form.onboarding.invalid_email'),
    }
  }

  return {
    valid: true,
  }
}
